/**
 * @fileoverview Kind data source and type definitions.
 */

import { KindSchema, type Kind } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAccountTrackingFields, createAuditFields, createLookupEntityFields } from './field-factories';
import { getCache } from './cache-registry';

export type { Kind };

export const kindDataSource = createBaseDataSource<Kind>({
  endpoint: 'kind',
  searchField: 'name',
  schema: KindSchema,
  fields: [
    ...createLookupEntityFields(),
    ...createAccountTrackingFields(),
    ...createAuditFields(),
  ],
});

export const kindCache = getCache('kind');
